import { NavLink } from 'react-router-dom'
import { useSideBarContext } from 'src/contexts/SideBarContext'

export const BigLink = ({ children, ...props }) => {
  const { hideSideBar } = useSideBarContext()
  return (
    <NavLink
      className="sidebarHb-link"
      activeClassName="active"
      {...props}
      onClick={() => {
        hideSideBar()
      }}
    >
      {children}
    </NavLink>
  )
}

export const SubLink = ({ children, ...props }) => {
  const { hideSideBar } = useSideBarContext()
  return (
    <NavLink
      activeClassName="active"
      {...props}
      onClick={() => {
        hideSideBar()
      }}
    >
      {children}
    </NavLink>
  )
}
